import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const registryPlatformProjectsApi = createApi({
  reducerPath: "registryPlatformProjectsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "",
  }),
  tagTypes: ["PlatformProjects"],
  endpoints: (build) => ({
    getPlatformProjects: build.query({
      query: () => "/api/projects/registry",
      providesTags: ["PlatformProjects"],
    }),
    getPlatformProjectDetails: build.query({
      query: (id) => `/api/projects/registry/${id}`,
      providesTags: ["PlatformProjects"],
    }),
    getPlatformProjectCredits: build.query({
      query: (id) => `/api/projects/registry/${id}/credits`,
      providesTags: ["PlatformProjects"],
    }),
  }),
});

export const {
  useGetPlatformProjectsQuery,
  useGetPlatformProjectDetailsQuery,
  useGetPlatformProjectCreditsQuery,
} = registryPlatformProjectsApi;
